import { useSelector } from "react-redux";

export const useModalData = (modalName) => useSelector((state) => state?.modal[modalName]?.data) || {};
